import React from 'react';
import { AppServices } from 'services/AppServices';
import Locale from 'localization/Localization';
import { Spinner } from 'components/common/Spinner';
import { ApiError } from 'models/ApiError';
import { ResultMessage, ResultStyle, ResultMessageView } from '../common/ResultMessageView';

interface ResetFormState
{
	userEmail: string;
	requestInProgress: boolean;
	requestSent: boolean;
	redirectPath: string | undefined;
	resultMessage: ResultMessage | undefined;
}

export class ResetForm extends React.Component<{}, ResetFormState>
{
	constructor(props: {})
	{
		super(props);

		this.state = {
			userEmail: '',
			requestInProgress: false,
			requestSent: false,
			redirectPath: undefined,
			resultMessage: undefined
		};

		this.onEmailChanged = this.onEmailChanged.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
	}

	private onEmailChanged(event: React.ChangeEvent<HTMLInputElement>)
	{
		this.setState({ userEmail: event.target.value });
	}

	private onSubmitClick(event: React.FormEvent<HTMLFormElement>)
	{
		event.preventDefault();

		this.setState({
			requestInProgress: true,
			resultMessage: undefined
		});

		AppServices.loginService.requestPasswordResetMail(this.state.userEmail)
			.then(() =>
			{
				this.setState({
					requestInProgress: false,
					requestSent: true
				});
			})
			.catch(reason =>
			{
				const message = Locale.get(reason === ApiError.InvalidParameter ? 'reset_errorInvalidEmail' : 'reset_errorSendFailed');

				this.setState({
					requestInProgress: false,
					resultMessage: new ResultMessage(message, ResultStyle.Error)
				});
			});
	}

	public render()
	{
		return (
			<div className='login-container'>
				{this.state.requestInProgress && <Spinner />}
				{this.state.requestInProgress === false && this.state.requestSent === false &&
					<React.Fragment>
						<h2>{Locale.get('reset_header')}</h2>
						<p>{Locale.get('reset_description')}</p>
						<form onSubmit={this.onSubmitClick}>
							<label className='input-label' htmlFor='resetUserEmail'>{Locale.get('reset_emailLabel')}</label>
							<input required type='email' id='resetUserEmail' onChange={this.onEmailChanged} />
							<div className='submit-container'>
								<input type='submit' value={Locale.get('reset_submitButton')} />
							</div>
						</form>
						<ResultMessageView message={this.state.resultMessage} />
					</React.Fragment>
				}
				{this.state.requestSent &&
					<React.Fragment>
						<h2>{Locale.get('reset_headerSent')}</h2>
						<p>{Locale.get('reset_descriptionSent')}</p>
					</React.Fragment>
				}
			</div>
		);
	}
}